export default __webpack_public_path__ + "static/media/11.9caf1907.svg";